import { render, staticRenderFns } from "./insuranceClaims.vue?vue&type=template&id=59a0b0d4&scoped=true&"
import script from "./insuranceClaims.vue?vue&type=script&lang=js&"
export * from "./insuranceClaims.vue?vue&type=script&lang=js&"
import style0 from "./insuranceClaims.vue?vue&type=style&index=0&id=59a0b0d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a0b0d4",
  null
  
)

export default component.exports